module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Join-2-54774d59cde36b59ceb064a0f978a39e.svg";